// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionWithAction_option__1uL7s","label":"OptionWithAction_label__11Ac_","labelTitle":"OptionWithAction_labelTitle__1g-1G"};